import { useTranslate } from "@tolgee/react";
import { Search } from "lucide-react";

type LearnSearchInputProps = {
	value: string;
	onChange: (value: string) => void;
};

export function LearnSearchInput({ value, onChange }: LearnSearchInputProps) {
	const { t } = useTranslate();
	const placeholder = t("learn.search.placeholder");

	return (
		<div className="relative mb-8">
			<Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
			<input
				type="search"
				value={value}
				onChange={(event) => onChange(event.target.value)}
				placeholder={placeholder}
				className="w-full rounded-lg border border-border bg-card py-2.5 pl-10 pr-4 text-body2 text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring"
			/>
		</div>
	);
}
